module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.0394372a.jpg";